module.exports = __webpack_public_path__ + "static/img/iphone_msp5.025c9ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msp5.png
// module id = lhmZ
// module chunks = 0